import {MiddlewareContext} from '@/lib/middleware'
import {App} from '@/project'
import {RootState} from '@/store'
import isFallbackLink from '@/validate/is-fallback-link'

interface Options {
  /**
   * Allow go next path even if the user has no phone
   */
  allowNoPhone: boolean
  /**
   * Allow go next path even if the user has no biz info
   */
  allowNoBiz: boolean
  /**
   * Set where go to after sign-in
   */
  fallbackSignIn: boolean
}

function getAuthenticated(store) {
  return store.getters['auth/authenticated']
}

function getPhone(store) {
  return store.getters['auth/hasPhone']
}

function getBiz(store) {
  return store.getters['biz/hasBiz']
}

function getFailbackSignIn(store) {
  return store.getters['auth/failbackSignIn']
}

function getFailbackSignUpPhone(store) {
  return store.getters['auth/failbackSignUpPhone']
}

function getFailbackSignUpBiz(store) {
  return store.getters['auth/failbackSignUpBiz']
}

/**
 * Runs when the router meta.middleware has 'authenticated'
 * @param ctx
 * @param options
 */
export async function beforeResolve(ctx: MiddlewareContext<App, RootState>,
                                    options: Options) {

  const {
    allowNoBiz = false, allowNoPhone = false,
    fallbackSignIn = isFallbackLink(ctx.to),
  } = options || {}

  const {store} = ctx

  /**
   * Can't do anything without store
   */
  if(!store) {
    throw new Error('[authenticated] middleware should have the store')
  }

  const to: any = {}
  const authenticated = getAuthenticated(store)

  if(fallbackSignIn) {
    to.query = {
      then: ctx.to.fullPath,
    }
  }

  /**
   * If this is the first visiting (first entering any page) and
   * authenticated is not empty, it tries to sign-in
   */
  if(store.state.auth.firstAuth && authenticated) {
    try {
      await store.dispatch('auth/connectKakao')
    } catch(e) {
      // skip error
      /**
       * make all auth to be default state
       */
      store.commit('auth/clear')
    }

    store.commit('auth/update', {firstAuth: false})
  }

  const hasPhone = getPhone(store)
  const hasBiz = getBiz(store)

  /*****************************************
   * Decide where to go
   */
  if(!authenticated) {
    to.path = getFailbackSignIn(store)
    ctx.next(to)
    return
  }

  if(!hasPhone && !allowNoPhone) {
    to.path = getFailbackSignUpPhone(store)
    ctx.next(to)
    return
  } else if(!hasPhone && allowNoPhone) {
    ctx.next()
    return
  }

  if(!hasBiz && !allowNoBiz) {
    to.path = getFailbackSignUpBiz(store)
    ctx.next(to)
    return
  }

  // todo his logic needs to be moved to an unauthenticated middleware
  if(hasBiz && allowNoBiz) {
    ctx.next(store.getters['auth/failbackMain'])
  }
  ctx.next()
  /***************************************/
}
